import gql from 'graphql-tag';

export const CREATE_TRAFFICKING_CUSTOM_FILTER = gql`
  mutation CREATE_TRAFFICKING_CUSTOM_FILTER($input: CreateTraffickingCustomFilterInput!) {
    createTraffickingCustomFilter(input: $input) {
      id
      filterName
      filterType
      visibility
      filterPayload
      createdBy
    }
  }
`;
